'use strict';

angular.module('TurneroApp').service('estadisticaService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Estadistica/:id', { id: '@Id_Estadistica' }, {
        Get_Turnos_En_Espera: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_En_Espera/',
        },
        Get_Turnos_Finalizados: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Finalizados/',
        },
        Get_Turnos_Agendados: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Agendados/',
        },
        Get_Turnos_Perdidos: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Perdidos/'
        },
        Get_Turnos_Agendados_Orden: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Agendados_Orden/'
        },
        Get_Turnos_Derivados: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Derivados/'
        },
        Get_Turnos_No_Presentes: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_No_Presentes/',
        },
        Get_Turnos_Salon: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_Salon/',
        },
        Get_Promedio_Actual: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Promedio_Actual/',
        },
        Get_Promedio_Dia: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Promedio_Dia/'
        },
        Get_Mas_Espera_Orden: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Mas_Espera_Orden/'
        },
        Get_Mas_Espera_No_Orden: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Mas_Espera_No_Orden/'
        },
        Get_Mas_Espera_Actual: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Mas_Espera_Actual/'
        },
        Get_Turnos_En_Atencion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Estadistica/Get_Turnos_En_Atencion/'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/estadisticaService.js